<span (click)="connect()">
  <ng-content></ng-content>
</span>
